import type { SectionType, SortType } from '@components/SitemapReport/types'
import type React from 'react'

import { clsJoin } from '@/utils'
import { SearchPages, SortSelect } from './components'
import css from './styles.module.css'

interface Props {
  title: string
  activeSection: SectionType
  onSearchChange: (value: string) => void
  onSortChange: (value: SortType) => void
  search: string
  sort: SortType
}

export const PagesHeader: React.FC<Props> = ({
  title,
  activeSection,
  onSearchChange,
  onSortChange,
  search,
  sort,
}) => (
  <div className={css.pages_header}>
    <div className={clsJoin(css.title, css[activeSection])}>{title}</div>
    <div className={css.left_col}>
      <SearchPages value={search} onChange={onSearchChange} />
      <SortSelect value={sort} onChange={onSortChange} />
    </div>
  </div>
)
